<template lang="pug">
    .check-all
        el-dropdown(
            placement="bottom-start"
            size="mini"
            @command="selectOption"
        )
            span.el-dropdown-link
                el-checkbox(
                    v-model="checkbox"
                    :indeterminate="checkbox && isIndeterminate"
                )
                template(v-if="showDropdown")
                    i.el-icon-arrow-down.el-icon--right
                    //- i.el-icon-fa-angle-down.fas.el-icon--right
                    //- .icon-wrap
                    //-     //- i.el-icon-arrow-down.el-icon--right
                    //-     i.el-icon-fa-angle-down.fas
            template(v-if="showDropdown")
                el-dropdown-menu(slot="dropdown")
                    el-dropdown-item(:icon="allIcon" command="check-all")
                        //- template(v-if="checked === 'all'") {{ $t('Deselect all {total}', { total }) }}
                        //- template(v-else) {{ $t('Select all {total}', { total }) }}
                        | {{ $t('Select all {total}', { total }) }}
                    el-dropdown-item(:icon="visibleIcon" command="check-visible")
                        //- template(v-if="checked === 'visible'") {{ $t('Deselect all on this page') }}
                        //- template(v-else) {{ $t('Select all on this page') }}
                        | {{ $t('Select all on this page') }}
</template>

<i18n>
{
    "en": {
        "Select all {total}": "Select all {total}",
        "Deselect all {total}": "Deselect all {total}"
    },
    "de": {
        "Select all {total}": "Alle {total} auswählen",
        "Deselect all {total}": "Alle {total} abwählen",
        "Select all on this page": "Alle auf dieser Seite auswählen",
        "Deselect all on this page": "Alle auf dieser Seite abwählen"
    }
}
</i18n>

<script>
export default {
    name: 'CheckAll',
    props: {
        total: {
            type: Number,
            default: 0
        },
        showDropdown: {
            type: Boolean,
            default: false
        },
        defaultEvent: {
            type: String,
            default: 'check-all' // possible values: check-all | check-visible
        },
        isIndeterminate: {
            type: Boolean,
            default: false
        },
        checked: {
            type: String,
            default: 'none' // possible values: none | all | visible
        }
    },
    computed: {
        checkbox: {
            get() {
                return ['all', 'visible'].includes(this.checked);
            },
            set(value) {
                this.$emit(this.defaultEvent, { value, indeterminate: this.isIndeterminate })
            }
        },
        // dropdown: {
        //     get() {
        //         return undefined;
        //     },
        //     set(value) {
        //         console.log('dropdown', value)
        //         this.$emit(this.defaultEvent, value)
        //     }
        // },
        allIcon() {
            let icon;
            if (this.checked === 'all') {
                if (this.isIndeterminate) icon = 'el-icon-fa-minus-square fas';
                else icon = 'el-icon-fa-check-square fas';
            } else if (this.checked !== 'visible' && this.defaultEvent === 'check-all') {
                // icon = 'el-icon-fa-check-square far';
            }
            return icon;
        },
        visibleIcon() {
            let icon;
            if (this.checked === 'visible') {
                if (this.isIndeterminate) icon = 'el-icon-fa-minus-square fas';
                else icon = 'el-icon-fa-check-square fas';
            } else if (this.checked !== 'all' && this.defaultEvent === 'check-visible') {
                // icon = 'el-icon-fa-check-square far';
            }
            return icon;
        },
    },
    methods: {
        selectOption(event) {
            let value = true;
            switch (event) {
                case 'check-all':
                    value = this.checked !== 'all' || this.checked === 'all' && this.isIndeterminate === true;
                    break;

                case 'check-visible':
                    value = this.checked !== 'visible' || this.checked === 'visible' && this.isIndeterminate === true;
                    break;
            }
            this.$emit(event, { value, indeterminate: this.isIndeterminate })
        }
    }
}
</script>

<style lang="sass" scoped>
.check-all
    white-space: nowrap
.el-dropdown-link
    cursor: pointer
    // color: #409EFF
    // .icon-wrap
    //     position: relative
    //     display: inline-flex
    //     justify-content: center
    //     align-items: center
    //     height: 14px
    //     width: 14px
    //     border: 1px solid $--border-color-base
    //     border-left: 0
    //     border-radius: 2px
    //     border-top-left-radius: 0
    //     border-bottom-left-radius: 0
    //     top: -1px
    i
        font-size: 0.7em
        position: relative
        // left: -18px
        top: -1px
        z-index: 1
    :deep() .el-checkbox__inner
        // width: 26px
</style>
